/**
 * Build a lowercase A-Z / 0-9 / _ identifier from a free-text label.
 */
export function slugify_entity_id(value = '') {
    return String(value)
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, '_')
        .replace(/^_+|_+$/g, '');
}

/**
 * Prefer English when filled, otherwise the user language, otherwise any filled lang.
 */
export function entity_id_from_translatable_name(name, user_lang) {
    const pick = (value) => {
        const text = value != null ? String(value).trim() : '';
        return text ? slugify_entity_id(text) : '';
    };

    const from_en = pick(name?.en);
    if (from_en)
        return from_en;

    const from_user = pick(name?.[user_lang]);
    if (from_user)
        return from_user;

    for (const value of Object.values(name || {})) {
        const from_any = pick(value);
        if (from_any)
            return from_any;
    }

    return '';
}

export const NEW_PRICING_ID_PREFIX = '__new_';

export function is_temporary_pricing_id(id) {
    return String(id || '').startsWith(NEW_PRICING_ID_PREFIX);
}

export function make_temporary_pricing_id() {
    return `${NEW_PRICING_ID_PREFIX}${Date.now()}`;
}

export function materialize_temporary_pricing_ids(pricings, user_lang) {
    const source = pricings || {};
    const next = {};
    const used = new Set();

    Object.keys(source).forEach((key) => {
        let final_key = key;
        if (is_temporary_pricing_id(key)) {
            const base = entity_id_from_translatable_name(source[key]?.name, user_lang) || 'pricing';
            final_key = unique_entity_id(base, used);
        }
        used.add(final_key);
        next[final_key] = source[key];
    });

    return next;
}

/**
 * Ensure `base` is unique among `used` ids (Set or array).
 */
export function unique_entity_id(base, used) {
    if (!base)
        return '';
    const taken = used instanceof Set ? used : new Set(used || []);
    if (!taken.has(base))
        return base;
    let suffix = 2;
    let candidate = `${base}_${suffix}`;
    while (taken.has(candidate)) {
        suffix += 1;
        candidate = `${base}_${suffix}`;
    }
    return candidate;
}
